var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"main-text text-container"},[_c('v-row',[_c('v-col',[_c('iframe',{attrs:{"src":"/crm/?page_id=58&orders"}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }